import styles from './courseModal.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import { TextInput } from 'src/components/text-input/TextInput';
import { Program } from '@src/types';
import { useCallback, useEffect, useState } from 'react';
import { useDuplicateCourseMutation } from '@api/graphql-codegen';
import Spinner from '@src/components/spinner/Spinner';

type Props = {
  open: boolean;
  onClose: () => void;
  onCustome: (newId: string, name: string) => void;
  course?: Program
};

function CourseModal(props: Props) {
  const { open, onClose, onCustome, course } = props;
  const [ name, setName ] = useState("")

  const [duplicateCourse, {loading}] = useDuplicateCourseMutation({
    onCompleted(data) {
      onCustome(data.duplicateCourse, name)
    },
  });

  useEffect(() => {
    if (course) {
      setName(course.name)
    }
  }, [course])

  const handleClose = () => {
    onClose();
  };

  const handleDuplicate = useCallback(() => {
    course && duplicateCourse({
      variables: {
        input: {
          originalCourseId: course.id,
          newCourseName: name
        }
      }
    })
  }, [duplicateCourse, course, name])

  return (
    <Modal open={open} onClose={handleClose} className={styles.wrapper}>
      <div>
        <div className={styles.title}>Please name this course</div>
          <div className={styles.content}>
            <TextInput hasError={false}  id={'name'} placeholder={'Course name'} value={name} label={''} onChange={(value) => {setName(value as string)}} />
            <div className={styles.action}>
              <Button disabled={loading} leftIcon={loading ? <Spinner width={20} height={20} /> : undefined} className={styles.okButton} onClick={handleDuplicate} label={'OK'}/>
            </div>
          </div>
      </div>
    </Modal>
  );
}

export default CourseModal;
